import { render, staticRenderFns } from "./Cartorios.vue?vue&type=template&id=61fbb898&scoped=true"
import script from "./Cartorios.vue?vue&type=script&lang=js"
export * from "./Cartorios.vue?vue&type=script&lang=js"
import style0 from "./Cartorios.vue?vue&type=style&index=0&id=61fbb898&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fbb898",
  null
  
)

export default component.exports